(function() {
  var container = document.getElementById(
    'zithara-form-container-fa7fd148-f80c-4767-979c-0fe1a2f51299'
  );
  if (!container) return;

  var script = document.createElement('script');
  script.src = "https://webforms.zithara.com/dist/scripts/embedForm.js?v=" + Date.now();
  script.async = true;
  script.crossOrigin = "anonymous";

  script.onload = function() {
    if (window.EmbedForm) {
      window.EmbedForm(
        "zithara-form-container-fa7fd148-f80c-4767-979c-0fe1a2f51299",
        "b7cc67c6-f18e-45cf-9f17-9b50559bcc6a",
        "eca00aa5-e8b2-4bd6-b35d-b6947716c7de"
      );
    }
  };

  document.head.appendChild(script);
})();